import { type ChipProps } from '@mint-lib/tw-components';

import { ScheduleTableType } from '../types/queryScheduler.js';

const statusDictionary: Record<
  ScheduleTableType['status'],
  { color: ChipProps['color']; label: string }
> = {
  active: {
    color: 'success',
    label: 'Active',
  },
  scheduled: {
    color: 'info',
    label: 'Scheduled',
  },
  expired: {
    color: 'error',
    label: 'Expired',
  },
};

export const getSchedulerStatus = (value: ScheduleTableType['status']) =>
  statusDictionary[value];
